// Created by:      Marcel Simma
// Copyright:       © 2020 Zewas OG
// Creation date:   08.08.2020
// Last edited:     09.08.2020
import React from "react";
import Loader from "react-loader-spinner";
import styled from "styled-components";
import Cookies from "universal-cookie";
import Brand from "../assets/images/Brand.jpg";
import colors from "../constants/colors";
import HeadingOne from "./HeadingOne";
import OrderComplete from "./OrderComplete";
import constants from "../constants/constants";
import StyledButton from "./StyledButton";

const cookies = new Cookies();

/**
 * @author Sandro Mennel
 * @param {string} location the parentLocation
 * @param {string} order the orderData
 * @param {string} total the subordererTotal
 * @param {string} initiator the initiator
 * @example <ThanksScreen order={order} location={"SingleBuyerPage"} />
 */

const ThanksScreen = ({
  order,
  location,
  total,
  initiator,
  alreadyOrdered,
}) => {
  if (total === undefined && location === "DataInputSubbesteller")
    return (
      <Loader
        height={200}
        width={100}
        type="ThreeDots"
        color={colors.YellowBrigthButton}
      />
    );

  return (
    //  <DataContainer location={location}>
    <DataContainer>
      <div>
        <HeadingOne title="Vielen Dank für deine Bestellung!" />
      </div>
      <Content location={location}>
        <StyledBrand src={Brand} />

        {initiator?.iban &&
        initiator?.bank &&
        location !== "SingleBuyerPage" ? (
          <div style={{ marginTop: "30px" }}>
            <Paragraph>
              Bitte Überweise den Betrag von <strong>€ {total}</strong> auf
              folgendes Konto
            </Paragraph>
            <DataParagraph>
              <Paragraph style={{ textAlign: "center" }}>
                {initiator?.iban.replace(/(.{4})/g, "$1 ").trim()}
                <br /> laufend auf {initiator?.bank}
              </Paragraph>
            </DataParagraph>
          </div>
        ) : location !== "DataInputSubbesteller" ? (
          <Initiator style={{ maxWidth: "500px", marginTop: "50px" }}>
            <Paragraph>
              Bitte Überweise den Betrag von <strong>€ {order?.total}</strong>{" "}
              vorab auf das angegebene Konto. Zur eindeutigen Zuordnung deiner
              Bestellung bitte Verwendungszweck anführen.
            </Paragraph>
            <Paragraph>
              Zahlungsempfänger: <strong>Melchior Simma</strong>
              <br />
              IBAN: <strong>AT22 2060 3000 0208 3681</strong>
              <br />
              BIC: <strong>SPEGAT21XXX</strong>
              <br />
              Überweisungsbetrag: <strong>€ {order?.total}</strong>
              <br />
              Verwendungszweck: <strong>{order?.orderNumber}</strong>
            </Paragraph>
            {order && (
              <StyledButton
                onClick={() => {
                  window.location.href = "./bestellhistorie";
                }}
                scale={"ORDER"}
                title={"Bestellhistorie"}
                color={colors.YellowBrigthButton}
                fontSize={"20px"}
              />
            )}
          </Initiator>
        ) : (
          <>
            <Paragraph>
              Bitte halte den Betrag von{" "}
              <strong>
                €{" "}
                {parseFloat(total?.replace(",", "."))
                  .toFixed(2)
                  .toString()
                  .replace(".", ",")}
              </strong>{" "}
              für {initiator?.name} bereit.
            </Paragraph>
            {alreadyOrdered && (
              <Paragraph>
                Deine Bestellung ist bereits abgeschlossen. Bitte kontaktiere
                für Änderungen den/die BestellinitiatorIn.{" "}
              </Paragraph>
            )}
          </>
        )}
      </Content>
    </DataContainer>
  );
};

const StyledBrand = styled.img`
  max-width: 494px;
  width: 100%;
  height: auto;
  align-self: center;
  margin-top: 50px;
  @media (max-width: 2000px) {
    max-width: 400px;
  }
`;
const Text = styled.p`
  margin: 0;
`;
const DataParagraph = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const DataContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;
const Content = styled.div`
  display: flex;
  flex-direction: ${(props) =>
    props.location == "SingleBuyerPage" || props.location == "MultipleBuyerPage"
      ? "row"
      : "column"};
  /* flex-direction: row; */
  justify-content: space-between;
  width: ${(props) => (props.location == "SingleBuyerPage" ? "70%" : "unset")};
  @media (max-width: 1500px) {
    flex-direction: column;
    width: 100%;
    /* height: 65vh; */
  }
  @media (max-width: 700px) {
    flex-direction: column;
    width: unset;
    /* height: 65vh; */
  }
`;

const Paragraph = styled.p`
  color: #808080;
  font-size: 16px;
  letter-spacing: 0.4px;
  font-family: "Montserrat";
  font-weight: 300;
  padding: 0;
`;

const Initiator = styled.div`
  max-width: 500px;
  margin-top: 50px;
  margin-left: 100px;
  @media (max-width: 1500) {
    margin-left: 0;
  }
  @media (max-width: ${constants.nexusPortraitWidth}px) {
    margin-left: 0;
  }
`;

export default ThanksScreen;
